export default __webpack_public_path__ + "/dist/images/pending-inactive.0d3a0435dc11b0aa46d5613b6bdc8a47.svg";